import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ProjectSection } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<
    UseQueryOptions<ProjectSection, Error>,
    'queryKey' | 'queryFn'
  >;
}

export const useSectionRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useQuery<ProjectSection, Error>(
    [Entities.Sections, id],
    async () => {
      const { data } = await api.v1AdminProjectSectionsProjectSectionIdGet(id)
      return data as ProjectSection
    },
    options,
  )
}
